// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".constrained-width[data-v-3fe503f5]{width:100%;max-width:640px;margin-left:auto;margin-right:auto}", ""]);
// Exports
module.exports = exports;
